import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const scrollToSection = (sectionId: string) => {
    if (!isHomePage) {
      // If not on home page, navigate to home first
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Account for fixed navigation height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    scrollToSection(sectionId);
  };
  return <nav className="fixed top-0 left-0 right-0 bg-white shadow-md z-50" data-id="element-216" data-mp="dhab1otmspce">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217" data-mp="hic9w4jmyzdu">
        <div className="flex justify-between items-center h-16" data-id="element-218" data-mp="mgduwv0mh8ry">
          {/* Logo/Brand */}
          <div className="flex-shrink-0" data-id="element-219" data-mp="rfgzyfglrezx">
            <Link to="/" className="text-xl font-bold text-black" data-id="element-220" data-mp="rgidcql3cdkt">
              I75 Audio & Video LLC
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8" data-id="element-221" data-mp="10fn6fhdvvepl">
            {isHomePage ? <>
                <a href="#hero" onClick={e => handleNavClick(e, 'hero')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-222" data-mp="156dfp5pfk1pk">
                  Home
                </a>
                <a href="#about" onClick={e => handleNavClick(e, 'about')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-223" data-mp="1f38b3fqeplzm">
                  About Us
                </a>
                <a href="#services" onClick={e => handleNavClick(e, 'services')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-224" data-mp="piguthlmxyp2">
                  Services
                </a>
                <a href="#work" onClick={e => handleNavClick(e, 'work')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-225" data-mp="1d5gr4iq2aml6">
                  Projects
                </a>
                <a href="#testimonials" onClick={e => handleNavClick(e, 'testimonials')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-226" data-mp="1i5upta5rwk6j">
                  Testimonials
                </a>
                <a href="#contact" onClick={e => handleNavClick(e, 'contact')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-227" data-mp="1zexb65ic300d">
                  Contact
                </a>
              </> : <>
                <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-228" data-mp="1unf9ff8hkvec">
                  Home
                </Link>
                <Link to="/#about" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-229" data-mp="1kr2cm8hna1fd">
                  About Us
                </Link>
                <Link to="/#services" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-230" data-mp="1bpusqvfvl34t">
                  Services
                </Link>
                <Link to="/#work" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-231" data-mp="362kkb6iru091">
                  Projects
                </Link>
                <Link to="/#testimonials" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-232" data-mp="1106vdxaktb1z">
                  Testimonials
                </Link>
                <Link to="/#contact" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-233" data-mp="n2rzqatqc71k">
                  Contact
                </Link>
              </>}
            <Link to="/blog" className="text-gray-700 hover:text-blue-600 transition-colors font-medium" data-id="element-234" data-mp="dcym74a11huo">
              Blog
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-235" data-mp="3vi1vl1710g0w">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-blue-600 focus:outline-none" aria-label="Toggle menu" data-id="element-236" data-mp="3vj3ajgr5xmnw">
              {isMenuOpen ? <X size={24} data-id="element-237" data-mp="2fx9f4h8yg8yr" /> : <Menu size={24} data-id="element-238" data-mp="2g16xv1rmeyi4" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-200" data-id="element-239" data-mp="2oyr46p4cbkzl">
          <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-240" data-mp="1s9rtz4k7494r">
            {isHomePage ? <>
                <a href="#hero" onClick={e => handleNavClick(e, 'hero')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-241" data-mp="1x8ctt2vjcqso">
                  Home
                </a>
                <a href="#about" onClick={e => handleNavClick(e, 'about')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-242" data-mp="19j0gprx37yl3">
                  About Us
                </a>
                <a href="#services" onClick={e => handleNavClick(e, 'services')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-243" data-mp="2bwg6ubxvh8sk">
                  Services
                </a>
                <a href="#work" onClick={e => handleNavClick(e, 'work')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-244" data-mp="1xwf2unmb9l8v">
                  Projects
                </a>
                <a href="#testimonials" onClick={e => handleNavClick(e, 'testimonials')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-245" data-mp="22w02l09b1xmn">
                  Testimonials
                </a>
                <a href="#contact" onClick={e => handleNavClick(e, 'contact')} className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" data-id="element-246" data-mp="3ltwnhfa506u9">
                  Contact
                </a>
              </> : <>
                <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-247" data-mp="3gxfotr5baa2x">
                  Home
                </Link>
                <Link to="/#about" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-248" data-mp="3uukzy5jvtz51">
                  About Us
                </Link>
                <Link to="/#services" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-249" data-mp="w6oxr6buvvqx">
                  Services
                </Link>
                <Link to="/#work" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-250" data-mp="2jgglcozd5q03">
                  Projects
                </Link>
                <Link to="/#testimonials" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-251" data-mp="37618lk2jv9f6">
                  Testimonials
                </Link>
                <Link to="/#contact" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-252" data-mp="1qsktpyonioa6">
                  Contact
                </Link>
              </>}
            <Link to="/blog" className="block px-3 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-253" data-mp="1gl013jjn5343">
              Blog
            </Link>
          </div>
        </div>}
    </nav>;
}